export default "__VITE_ASSET__99IdvKeM__"